import { BaseDto } from './base.dto';
import { PrintConfigurationDto } from './printConfiguration.dto';
import { PrintEntityFilteringOptionDto } from './printEntityFilteringOption.dto';
export class PrintConfigurationEntityFilteringValueDto extends BaseDto{

    printEntityFilteringOption: PrintEntityFilteringOptionDto;
    

    printConfiguration: PrintConfigurationDto;
    

    value: any[];
}